import { useNavigate, useLocation } from 'react-router-dom';
import '../../css/shared/SportFilter.css';
import { Icon } from '../../utils/icons';

const SPORTS = [
  { id: 'football',          label: 'Football',          path: '/football',          icon: 'sport-football',          color: '#0f891f' },
  { id: 'basketball',        label: 'Basketball',        path: '/basketball',        icon: 'sport-basketball',        color: '#fca601' },
  { id: 'tennis',            label: 'Tennis',            path: '/tennis',            icon: 'sport-tennis',            color: '#f8c83c' },
  { id: 'tabletennis',       label: 'Table Tennis',      path: '/table-tennis',      icon: 'sport-tabletennis',       color: '#c8ec1a' },
  { id: 'volleyball',        label: 'Volleyball',        path: '/volleyball',        icon: 'sport-volleyball',        color: '#76e1ff' },
  { id: 'rugby',             label: 'Rugby',             path: '/rugby',             icon: 'sport-rugby',             color: '#e07b39' },
  { id: 'american-football', label: 'Am. Football',      path: '/american-football', icon: 'sport-american-football', color: '#8187f6' },
  { id: 'handball',          label: 'Handball',          path: '/handball',          icon: 'sport-handball',          color: '#e040fb' },
  { id: 'mma',               label: 'MMA',               path: '/mma',               icon: 'sport-mma',               color: '#ff4757' },
  { id: 'icehockey',         label: 'Ice Hockey',        path: '/ice-hockey',        icon: null,                      color: '#4e96cb' },
];

function IceHockeyIcon({ color }) {
  return (
    <svg className="sport-icon" viewBox="0 0 12 8.571" width="13" height="9">
      <path fill={color} d="M 12 4.286 L 12 5.357 C 12 7.132 9.314 8.571 6 8.571 C 2.745 8.571 0.096 7.183 0.003 5.452 L 0 5.357 L 0 4.286 C 0 6.061 2.686 7.5 6 7.5 C 9.314 7.5 12 6.061 12 4.286 Z M 6 0 C 9.314 0 12 1.439 12 3.214 C 12 4.99 9.314 6.429 6 6.429 C 2.686 6.429 0 4.989 0 3.214 C 0 1.439 2.686 0 6 0 Z" />
    </svg>
  );
}

export default function SportFilter() {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const activeId = SPORTS.find(s => pathname === s.path || pathname.startsWith(s.path + '/'))?.id || null;

  return (
    <div className="sportfilter">
      {SPORTS.map((s) => {
        const isActive = activeId === s.id;
        return (
          <button
            key={s.id}
            className={'sport-chip' + (isActive ? ' is-active' : '')}
            style={isActive ? {
              background: `linear-gradient(180deg, rgba(0,0,0,0) -9%, ${s.color}8a 144%), #1d1c3c`,
              boxShadow: `inset 0 0 0 1px ${s.color}8c`,
            } : undefined}
            onClick={() => navigate(s.path)}
          >
            {s.icon
              ? <Icon className="sport-icon" name={s.icon} w={14} h={14} color={isActive ? s.color : '#757490'} />
              : <IceHockeyIcon color={isActive ? s.color : '#757490'} />
            }
            <span className="sport-label">{s.label}</span>
          </button>
        );
      })}
    </div>
  );
}
